import { useEffect, useState } from "react";
import { read } from "xlsx";

const fileToWorkbook = (file: any) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
            resolve(read(reader.result, { sheetRows: 11 })); // Read only first 10 rows (header + 10 data rows)
        };
        reader.onerror = () => {
            // could not parse the file
            reject();
        };
        reader.readAsArrayBuffer(file);
    });
}

export const useLoadWorkSheet = (file:any) => {
    const [isLoading, setIsLoading] = useState(false);
    const [workSheet, setWorkSheet] = useState<any>(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!file) {
            setWorkSheet(null);
            return;
        }
        (async () => {
            try {
                const workBook: any = await fileToWorkbook(file)
                setWorkSheet(workBook.Sheets[workBook.SheetNames[0]])
            } catch (err: any) {
                setError(err);
            }
        })();
    }, [file, setIsLoading]);

    return { isLoading, error, workSheet };
}